<template lang="pug">
#interest-page.grid-scroll-more(v-if='!loading', v-scrolled-to-end='loadMore')
  #ip-info
    template(v-if='$breakpoint.isTouch')
      #ip-name {{ interest.name }}
        #ip-likes-count
          span {{ likeCountText }}
          #ip-like-action(@click='likeInterst') {{ likedText }}

    template(v-else)
      #ip-name {{ interest.name }}
      #ip-likes-count {{ likeCountText }}
      #ip-like-action(@click='likeInterst') {{ likedText }}

    SortByMenu(@sortBy='setSortOrder', :sortOptions='sortOptions', placement='bottom-end')

  GridDisplay(:entities='users')
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {},

  data() {
    return {
      currentPage: 1,
      interest: null,
      loading: true,
      sortOrder: 'recent',
      sortOptions: ['recent', 'most visits'],
    }
  },
  channels: {
    InterestChannel: {
      connected() {},
      rejected() {},
      received(data) {
        if (this.sortOrder == 'recent') {
          this.$store.commit('users/ADD_OR_UPDATE', data)
        } else {
          this.$store.commit('users/UPDATE', data)
        }
      },
      disconnected() {},
    },
  },

  computed: {
    ...mapGetters({
      findBySlug: 'interests/findBySlug',
      userSortBy: 'users/sortBy',
    }),
    likeCountText,
    likedText,
    users,
  },

  watch: {},

  methods: {
    fetchUsers,
    likeInterst,
    loadMore,
    setSortOrder,
  },

  async created() {
    this.loading = true
    await this.$store.dispatch('interests/fetchSingle', this.$route.params.slug)

    this.interest = this.findBySlug(this.$route.params.slug)

    this.$cable.subscribe({ channel: 'InterestChannel', id: this.interest.id })

    this.loading = false
  },

  components: {
    GridDisplay: require('@/components/GridDisplay').default,
    SortByMenu: require('@/components/SortByMenu').default,
  },
}

/* Computed ---------------------------------------------------- */
function likeCountText() {
  const text = this.$options.filters.pluralize('Like', 'Likes', this.interest.likesCount)
  return `${this.interest.likesCount} ${text}`
}

function likedText() {
  return this.interest.liked ? 'Liked' : 'Like'
}

function users() {
  return this.userSortBy(this.sortOrder)
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
async function fetchUsers() {
  await this.$store.dispatch('interests/fetchPeople', {
    slug: this.interest.slug,
    page: this.currentPage,
    sort: this.sortOrder,
  })
}

async function likeInterst() {
  if (this.interest.liked) {
    await this.$store.dispatch('interests/unlike', this.interest.id)
  } else {
    const data = {
      id: this.interest.slug,
      page: this.currentPage,
      sort: this.sortOrder,
    }

    await this.$store.dispatch('interests/like', data)
    // this.fetchUsers()
  }
}

async function loadMore(load = false) {
  if (load) {
    this.currentPage++
    await this.fetchUsers()
  }
}

function setSortOrder(order) {
  this.sortOrder = order
  this.fetchUsers()
}
</script>
